import { Theme } from '@mui/material';

import { IconName } from '@/components/Icon';

export enum OptionValue {
  All = 'all',
  None = 'none',
}

export type Option = {
  value: string | number;
  text?: string;
  icon?: IconName;
  group?: string;
  groupOrder?: number;
  disabled?: boolean;
  i18nKey?: string;
};

export type ColorExtractFn = (theme: Theme) => string | undefined;
